export const mockLayout = {
  'communityMenu': null,
  'corporateMenu': {
    'menu': [
      {
        'items': [
          {
            'parent': null,
            'id': 1,
            'visible': true,
            'access_rights': [],
            'label': 'Accueil',
            'slug': 'accueil',
            'target_object': {
              'type': 'menu',
              'label': 'Accueil',
              'menu': [
                {
                  'parent': 1,
                  'id': 2,
                  'visible': true,
                  'access_rights': [],
                  'label': 'Présentation',
                  'slug': 'presentation',
                  'target_object': {
                    'type': 'external_link',
                    'uid': 'https://example.com/presentation',
                    'label': 'Présentation'
                  }
                },
                {
                  'parent': 1,
                  'id': 3,
                  'visible': true,
                  'access_rights': [],
                  'label': 'Contact',
                  'slug': 'contact',
                  'target_object': {
                    'type': 'external_link',
                    'uid': 'https://example.com/contact',
                    'label': 'Contact'
                  }
                }
              ]
            },
            'order': 0
          },
          {
            'parent': null,
            'id': 4,
            'visible': true,
            'access_rights': [],
            'label': 'Services',
            'slug': 'services',
            'target_object': {
              'type': 'menu',
              'menu': [
                {
                  'parent': 4,
                  'id': 5,
                  'visible': true,
                  'access_rights': [],
                  'label': 'Consulting',
                  'slug': 'consulting',
                  'target_object': {
                    'slug': 'consulting',
                    'type': 'strapi',
                    'instance': 'portal',
                    'uid': 'https://example.com/contact',
                    'menu': []
                  },
                  'order': 0
                },
                {
                  'parent': 4,
                  'id': 6,
                  'visible': true,
                  'access_rights': [],
                  'label': 'Formation',
                  'slug': 'formation',
                  'target_object': {
                    'slug': 'formation',
                    'type': 'strapi',
                    'instance': 'portal',
                    'uid': 'https://example.com/contact',
                    'menu': []
                  },
                  'order': 1
                }
              ]
            },
            'order': 1
          }
        ]
      }
    ]
  },
  'name': '_MOCK_LAYOUT_',
  'siteURL': '/fr'
};

export const mockInternalPageSimpleLayout = {
  filAriane: [
    { label: 'Accueil', navigationPath: '/fr' },
    { label: 'Formations', navigationPath: null },
    {
      label: 'Page mock',
      navigationPath: '/fr/mock'
    }
  ],
  url: '/fr',
  lang: ''
};

export const mockRelatedContent = [
  {
    'content': [
      {
        '__typename': 'CmsPortalComponentWidgetActionElement',
        'id': '3941',
        'URL': 'https://forms.sciencespo.fr/telecharger-brochure',
        'actionColor': 'BLACK',
        'icon': 'DOWNLOAD',
        'label': 'TÉLÉCHARGER NOTRE BROCHURE',
        'new_window': true
      }
    ]
  },
  {
    'content': [
      {
        '__typename': 'CmsPortalComponentWidgetActionElementList',
        'id': '1091',
        'actionListColor': 'RED',
        'title': 'Candidats',
        'action': [
          {
            'URL': 'https://www.sciencespo.fr/admissions/fr',
            'color': 'RED',
            'icon': 'FILE_TEXT',
            'id': '3944',
            'label': 'Procédure d\'admission',
            'new_window': true
          },
          {
            'URL': 'https://forms.sciencespo.fr/telecharger-guide-candidature',
            'color': 'RED',
            'icon': 'BOOK',
            'id': '3947',
            'label': 'Guide de candidature',
            'new_window': true
          },
          {
            'URL': 'https://forms.sciencespo.fr/telecharger-droits-scolarite',
            'color': 'RED',
            'icon': 'EURO',
            'id': '3950',
            'label': 'Guide des droits de scolarités & bourses',
            'new_window': true
          },
          {
            'URL': 'https://forms.sciencespo.fr/telecharger-guide-carrieres',
            'color': 'RED',
            'icon': 'BOOK',
            'id': '3953',
            'label': 'Guide des services carrières',
            'new_window': true
          }
        ]
      }
    ]
  },
  {
    'content': [
      {
        '__typename': 'CmsPortalComponentWidgetKeyFigureList',
        'id': '1319',
        'title': 'Chiffres clés',
        'keyFigureColor': 'RED',
        'figures': [
          {
            'id': '5840',
            'label': '15000',
            'value': 'éudiants'
          },
          {
            'id': '5843',
            'label': '50 %',
            'value': 'd\'étudiants internationaux'
          },
          {
            'id': '5846',
            'label': '150',
            'value': 'nationalités'
          },
          {
            'id': '5849',
            'label': '25 %',
            'value': 'de boursiers'
          },
          {
            'id': '5852',
            'label': '38 %',
            'value': 'de nos diplômés travaillent à l\'étranger'
          },
          {
            'id': '5855',
            'label': '80 %',
            'value': 'de nos diplômés trouvent leur premier emploi en moins de 6 mois'
          }
        ]
      }
    ]
  },
  {
    'content': [
      {
        '__typename': 'CmsPortalComponentWidgetThumbnail',
        'id': '2873',
        'thumbnailColor': 'RED',
        'content': '<figure class="image"><div data-gatsby-image-wrapper="" style="position:relative;overflow:hidden;display:inline-block;vertical-align:top" class="gatsby-image-wrapper gatsby-image-wrapper-constrained  inline-gatsby-image-wrapper"><div style="max-width:500px;display:block"><img alt="" role="presentation" aria-hidden="true" src="data:image/svg+xml;charset=utf-8,%3Csvg%20height=&#x27;281&#x27;%20width=&#x27;500&#x27;%20xmlns=&#x27;http://www.w3.org/2000/svg&#x27;%20version=&#x27;1.1&#x27;%3E%3C/svg%3E" style="max-width:100%;display:block;position:static"></div><div aria-hidden="true" data-placeholder-image="" style="height:100%;left:0;position:absolute;top:0;width:100%"></div><img data-gatsby-image-ssr="" data-ecoweb-inline-image="1" data-main-image="" style="height:100%;left:0;position:absolute;top:0;transform:translateZ(0);transition:opacity 250ms linear;width:100%;will-change:opacity;opacity:0" sizes="(min-width: 500px) 500px, 100vw" decoding="async" loading="eager" src="/static/d9a9dd2eebf01f789ec3264c3fecf7b0/b0a15/visite_virtuelle_paris_000_1_435668fa87.webp" srcSet="/static/d9a9dd2eebf01f789ec3264c3fecf7b0/b0a15/visite_virtuelle_paris_000_1_435668fa87.webp 125w,/static/d9a9dd2eebf01f789ec3264c3fecf7b0/b0a15/visite_virtuelle_paris_000_1_435668fa87.webp 250w,/static/d9a9dd2eebf01f789ec3264c3fecf7b0/b0a15/visite_virtuelle_paris_000_1_435668fa87.webp 500w" alt=""><noscript><img data-gatsby-image-ssr="" data-ecoweb-inline-image="1" data-main-image="" style="height:100%;left:0;position:absolute;top:0;transform:translateZ(0);transition:opacity 250ms linear;width:100%;will-change:opacity;opacity:0" sizes="(min-width: 500px) 500px, 100vw" decoding="async" loading="eager" src="/static/d9a9dd2eebf01f789ec3264c3fecf7b0/b0a15/visite_virtuelle_paris_000_1_435668fa87.webp" srcSet="/static/d9a9dd2eebf01f789ec3264c3fecf7b0/b0a15/visite_virtuelle_paris_000_1_435668fa87.webp 125w,/static/d9a9dd2eebf01f789ec3264c3fecf7b0/b0a15/visite_virtuelle_paris_000_1_435668fa87.webp 250w,/static/d9a9dd2eebf01f789ec3264c3fecf7b0/b0a15/visite_virtuelle_paris_000_1_435668fa87.webp 500w" alt=""/></noscript><script type="module">const t="undefined"!=typeof HTMLImageElement&&"loading"in HTMLImageElement.prototype;if(t){const t=document.querySelectorAll("img[data-main-image]");for(let e of t){e.dataset.src&&(e.setAttribute("src",e.dataset.src),e.removeAttribute("data-src")),e.dataset.srcset&&(e.setAttribute("srcset",e.dataset.srcset),e.removeAttribute("data-srcset"));const t=e.parentNode.querySelectorAll("source[data-srcset]");for(let e of t)e.setAttribute("srcset",e.dataset.srcset),e.removeAttribute("data-srcset");e.complete&&(e.style.opacity=1,e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity=0)}}</script></div><figcaption><span style="background-color:rgb(242,243,245);color:rgb(47,52,61);">Visitez nos campus</span></figcaption></figure><p>Plongez au cœur de nos campus et naviguez à travers les amphis, la bibliothèque, les salles de classe et bien d’autres lieux de vie.</p><p><a href="https://eco-web-pprd.sciences-po.fr/fr/a-propos/nos-campus/visites-virtuelles-campus">Visitez nos campus</a></p>',
        'title': 'Visites virtuelles de nos campus'
      }
    ]
  }
];

export const mockSectionContent = {
  'elem': {
    'title': 'Focus',
    'three_columns': false,
    'spacing': false,
    'content': [
      {
        'col_span': 2,
        'row_span': 2,
        'widget': {
          'content': [
            {
              '__typename': 'CmsPortalComponentWidgetNewsItem',
              'id': '254',
              'news': {
                'id': '7d6013c2-a7a5-541c-b695-d73675b41d55',
                'authors': null,
                'categories': [
                  {
                    'id': '39d85664-9a8e-5ec2-bfc5-72e1c5b2707b',
                    'description': null,
                    'label': 'Admissions',
                    'subcategories': []
                  }
                ],
                'subcategories': [],
                'seo': null,
                'cover': {
                  'id': '224afca7-71a1-51e3-9331-b8363d9f479a',
                  'name': 'shutterstock_2253613013.jpg',
                  'captionEN': null,
                  'caption': '',
                  'creator': null,
                  'alternativeTextEN': null,
                  'alternativeText': 'Site internet Parcoursup ',
                  'url': '/uploads/shutterstock_2253613013_eee15a231f.jpg',
                  'imageFile': {
                    'childImageSharp': {
                      'gatsbyImageData': {
                        'layout': 'constrained',
                        'images': {
                          'fallback': {
                            'src': '/static/0b3313322c0835138c692c960d986aca/1b035/shutterstock_2253613013_eee15a231f.jpg',
                            'srcSet': '/static/0b3313322c0835138c692c960d986aca/99f43/shutterstock_2253613013_eee15a231f.jpg 250w,\n/static/0b3313322c0835138c692c960d986aca/28380/shutterstock_2253613013_eee15a231f.jpg 500w,\n/static/0b3313322c0835138c692c960d986aca/1b035/shutterstock_2253613013_eee15a231f.jpg 1000w',
                            'sizes': '(min-width: 1000px) 1000px, 100vw'
                          },
                          'sources': [
                            {
                              'srcSet': '/static/0b3313322c0835138c692c960d986aca/48571/shutterstock_2253613013_eee15a231f.webp 250w,\n/static/0b3313322c0835138c692c960d986aca/76f01/shutterstock_2253613013_eee15a231f.webp 500w,\n/static/0b3313322c0835138c692c960d986aca/b7ef5/shutterstock_2253613013_eee15a231f.webp 1000w',
                              'type': 'image/webp',
                              'sizes': '(min-width: 1000px) 1000px, 100vw'
                            }
                          ]
                        },
                        'width': 1000,
                        'height': 667
                      }
                    }
                  }
                },
                'entities': [
                  {
                    'description': null,
                    'id': 'd9395f8a-bbbb-5b31-a1ad-ff219deb6ca6',
                    'name': 'Direction de la communication (DCOM)'
                  },
                  {
                    'description': null,
                    'id': '115430bb-3acb-57c3-a312-800972ae01e8',
                    'name': 'Collège universitaire'
                  }
                ],
                'heading': 'Les inscriptions sur Parcoursup pour les futurs bacheliers sont ouvertes depuis le 18 janvier ! Explications et mode d’emploi.',
                'slug': 'sciences-po-sur-parcoursup-comment-ca-marche',
                'canonical_link': 'https://www.sciencespo.fr/fr/actualites/sciences-po-sur-parcoursup-comment-ca-marche',
                'show_cover_media': false,
                'publishedAt': '2023-05-04T19:33:54.275Z',
                'title': 'Sciences Po sur Parcoursup : comment ça marche ??'
              }
            }
          ]
        }
      },
      {
        'col_span': 1,
        'row_span': 1,
        'widget': {
          'content': [
            {
              '__typename': 'CmsPortalComponentWidgetLink',
              'id': '6455',
              'new_window': false,
              'target_link': 'https://eco-web-pprd.sciences-po.fr/fr/a-propos-de-fariba-adelkhah-ce-que-lon-sait',
              'frame': false,
              'titleLink': 'Fariba Adelkhah',
              'content': '',
              'titleOrientation': 'CENTER',
              'background': {
                'id': 'c7b2e987-39a8-5404-be6b-ab3b62f29177',
                'name': 'scpo-fariba-3ans.png',
                'captionEN': null,
                'caption': 'Portrait de Fariba Adelkhah',
                'creator': null,
                'alternativeTextEN': null,
                'alternativeText': 'Portrait de Fariba Adelkhah',
                'url': '/uploads/scpo_fariba_3ans_c04391fd5a.png',
                'imageFile': {
                  'childImageSharp': {
                    'gatsbyImageData': {
                      'layout': 'constrained',
                      'images': {
                        'fallback': {
                          'src': '/static/db64f418d427663b98a9fba6d4c659f6/46029/scpo_fariba_3ans_c04391fd5a.png',
                          'srcSet': '/static/db64f418d427663b98a9fba6d4c659f6/bb5d0/scpo_fariba_3ans_c04391fd5a.png 126w,\n/static/db64f418d427663b98a9fba6d4c659f6/0fd39/scpo_fariba_3ans_c04391fd5a.png 251w,\n/static/db64f418d427663b98a9fba6d4c659f6/46029/scpo_fariba_3ans_c04391fd5a.png 502w',
                          'sizes': '(min-width: 502px) 502px, 100vw'
                        },
                        'sources': [
                          {
                            'srcSet': '/static/db64f418d427663b98a9fba6d4c659f6/fabbe/scpo_fariba_3ans_c04391fd5a.webp 126w,\n/static/db64f418d427663b98a9fba6d4c659f6/63843/scpo_fariba_3ans_c04391fd5a.webp 251w,\n/static/db64f418d427663b98a9fba6d4c659f6/313d8/scpo_fariba_3ans_c04391fd5a.webp 502w',
                            'type': 'image/webp',
                            'sizes': '(min-width: 502px) 502px, 100vw'
                          }
                        ]
                      },
                      'width': 502,
                      'height': 502
                    }
                  }
                }
              },
              'style': null
            }
          ]
        }
      },
      {
        'col_span': 1,
        'row_span': 1,
        'widget': {
          'content': [
            {
              '__typename': 'CmsPortalComponentWidgetLink',
              'id': '7253',
              'new_window': true,
              'target_link': 'https://eco-web-pprd.sciences-po.fr/fr/guerre-en-ukraine',
              'frame': null,
              'titleLink': 'Guerre en Ukraine',
              'content': null,
              'titleOrientation': 'CENTER',
              'background': {
                'id': '124b0441-128c-5afd-9792-8f564fcf67a5',
                'name': 'scpo-ukraine-3-square.jpg',
                'captionEN': null,
                'caption': 'Façade du 27 rue Saint Guillaume aux couleurs du drapeau ukrainien',
                'creator': null,
                'alternativeTextEN': null,
                'alternativeText': 'Façade du 27 rue Saint Guillaume aux couleurs du drapeau ukrainien',
                'url': '/uploads/scpo_ukraine_3_square_384eb6fae6.jpg',
                'imageFile': {
                  'childImageSharp': {
                    'gatsbyImageData': {
                      'layout': 'constrained',
                      'images': {
                        'fallback': {
                          'src': '/static/f51042c8e1fc6f2e9ae984e5149bda0e/474a9/scpo_ukraine_3_square_384eb6fae6.jpg',
                          'srcSet': '/static/f51042c8e1fc6f2e9ae984e5149bda0e/e13ba/scpo_ukraine_3_square_384eb6fae6.jpg 126w,\n/static/f51042c8e1fc6f2e9ae984e5149bda0e/8c565/scpo_ukraine_3_square_384eb6fae6.jpg 251w,\n/static/f51042c8e1fc6f2e9ae984e5149bda0e/474a9/scpo_ukraine_3_square_384eb6fae6.jpg 502w',
                          'sizes': '(min-width: 502px) 502px, 100vw'
                        },
                        'sources': [
                          {
                            'srcSet': '/static/f51042c8e1fc6f2e9ae984e5149bda0e/fabbe/scpo_ukraine_3_square_384eb6fae6.webp 126w,\n/static/f51042c8e1fc6f2e9ae984e5149bda0e/63843/scpo_ukraine_3_square_384eb6fae6.webp 251w,\n/static/f51042c8e1fc6f2e9ae984e5149bda0e/313d8/scpo_ukraine_3_square_384eb6fae6.webp 502w',
                            'type': 'image/webp',
                            'sizes': '(min-width: 502px) 502px, 100vw'
                          }
                        ]
                      },
                      'width': 502,
                      'height': 502
                    }
                  }
                }
              },
              'style': null
            }
          ]
        }
      },
      {
        'col_span': 1,
        'row_span': 1,
        'widget': {
          'content': [
            {
              '__typename': 'CmsPortalComponentWidgetMarketing',
              'id': '305',
              'target_link_marketing': 'https://forms.sciencespo.fr/telecharger-guide-candidature',
              'target_link_alt': '',
              'target_link_label': '',
              'text': 'Demandez le guide de candidature',
              'icon': 'BOOK',
              'type': 'DOWNLOAD',
              'color': 'RED',
              'background': {
                'id': '47d91b10-74db-508e-9489-705f92555adb',
                'name': 'cta-guide-candidature-sciencsepo-1.png',
                'captionEN': null,
                'caption': '',
                'creator': null,
                'alternativeTextEN': null,
                'alternativeText': '',
                'url': '/uploads/cta_guide_candidature_sciencsepo_1_6255e3a697.png',
                'imageFile': {
                  'childImageSharp': {
                    'gatsbyImageData': {
                      'layout': 'constrained',
                      'images': {
                        'fallback': {
                          'src': '/static/ec54e6a46c04498e81a498b0681c2628/3ef0f/cta_guide_candidature_sciencsepo_1_6255e3a697.png',
                          'srcSet': '/static/ec54e6a46c04498e81a498b0681c2628/dddda/cta_guide_candidature_sciencsepo_1_6255e3a697.png 203w,\n/static/ec54e6a46c04498e81a498b0681c2628/bd1b6/cta_guide_candidature_sciencsepo_1_6255e3a697.png 406w,\n/static/ec54e6a46c04498e81a498b0681c2628/3ef0f/cta_guide_candidature_sciencsepo_1_6255e3a697.png 812w',
                          'sizes': '(min-width: 812px) 812px, 100vw'
                        },
                        'sources': [
                          {
                            'srcSet': '/static/ec54e6a46c04498e81a498b0681c2628/6f337/cta_guide_candidature_sciencsepo_1_6255e3a697.webp 203w,\n/static/ec54e6a46c04498e81a498b0681c2628/3a205/cta_guide_candidature_sciencsepo_1_6255e3a697.webp 406w,\n/static/ec54e6a46c04498e81a498b0681c2628/077a8/cta_guide_candidature_sciencsepo_1_6255e3a697.webp 812w',
                            'type': 'image/webp',
                            'sizes': '(min-width: 812px) 812px, 100vw'
                          }
                        ]
                      },
                      'width': 812,
                      'height': 812
                    }
                  }
                }
              }
            }
          ]
        }
      },
      {
        'col_span': 1,
        'row_span': 1,
        'widget': {
          'content': [
            {
              '__typename': 'CmsPortalComponentWidgetMarketing',
              'id': '302',
              'target_link_marketing': 'https://forms.sciencespo.fr/telecharger-brochure',
              'target_link_alt': '',
              'target_link_label': '',
              'text': 'TÉLÉCHARGEZ NOTRE BROCHURE',
              'icon': 'DOWNLOAD',
              'type': 'DOWNLOAD',
              'color': 'DARK_RED',
              'background': {
                'id': '9c352211-d1b2-5d4f-b4e1-c087be6afc0e',
                'name': 'cta_brochure_generale_sciencsepo_v2.png',
                'captionEN': null,
                'caption': '',
                'creator': null,
                'alternativeTextEN': null,
                'alternativeText': '',
                'url': '/uploads/cta_brochure_generale_sciencsepo_v2_b3c8a23f55.png',
                'imageFile': {
                  'childImageSharp': {
                    'gatsbyImageData': {
                      'layout': 'constrained',
                      'images': {
                        'fallback': {
                          'src': '/static/41bf5d84608a473712777f5c861314cf/3ef0f/cta_brochure_generale_sciencsepo_v2_b3c8a23f55.png',
                          'srcSet': '/static/41bf5d84608a473712777f5c861314cf/dddda/cta_brochure_generale_sciencsepo_v2_b3c8a23f55.png 203w,\n/static/41bf5d84608a473712777f5c861314cf/bd1b6/cta_brochure_generale_sciencsepo_v2_b3c8a23f55.png 406w,\n/static/41bf5d84608a473712777f5c861314cf/3ef0f/cta_brochure_generale_sciencsepo_v2_b3c8a23f55.png 812w',
                          'sizes': '(min-width: 812px) 812px, 100vw'
                        },
                        'sources': [
                          {
                            'srcSet': '/static/41bf5d84608a473712777f5c861314cf/6f337/cta_brochure_generale_sciencsepo_v2_b3c8a23f55.webp 203w,\n/static/41bf5d84608a473712777f5c861314cf/3a205/cta_brochure_generale_sciencsepo_v2_b3c8a23f55.webp 406w,\n/static/41bf5d84608a473712777f5c861314cf/077a8/cta_brochure_generale_sciencsepo_v2_b3c8a23f55.webp 812w',
                            'type': 'image/webp',
                            'sizes': '(min-width: 812px) 812px, 100vw'
                          }
                        ]
                      },
                      'width': 812,
                      'height': 812
                    }
                  }
                }
              }
            }
          ]
        }
      }
    ],
    '__typename': 'CmsPortalComponentSectionMain'
  },
  'hasNoTitle': true,
  'language': '',
  'locale': 'fr',
  'siteURL': '/fr',
  'tweets': [],
  'youtubeVideos': [],
  'content': [],
  'spacing': false,
  'three_columns': false,
  'title': ''
};